export enum UserRole {
    User = 'USER',
    Broker = 'BROKER',
    FitnessExpert = 'FITNESS_EXPERT',
    Sales = 'AIMO_SALES'
}
